<!-- TODO: Multilang -->

<!--
-->

<template>
  <div>
    <v-dialog
      v-model="show_dialog"
    >
      <template v-slot:activator="{ on, attrs }" class="explorerdirectory-header pl-2">
        <v-btn
          :disabled="!can_create"
          v-bind="attrs"
          v-on="on"
          icon
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <!--
      :search="search"
        :expanded="expanded"
      -->
      <v-card class="mx-auto">
        <v-card-title>
          <div style="display: flex; justify-content: space-between; flex-grow: 1;">
            <div class="d-flex">
              <div>Editor de carpetas</div>
              <v-btn
                rounded
                small
                fab
                color="primary"
                class="add-button-fab mb-2 ml-2"
                @click.stop="open_add({})"
                :disabled="!can_create"
              >
                <v-icon small>mdi-plus-thick</v-icon>
              </v-btn>
            </div>
            <div style="width: fit-content; display: flex;">
              <SearchTextTable @input="setSearchText" />
            
              <v-btn
                icon
                @click="close_dialog"
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-data-table
          v-model="table_select"
          :headers="headers"
          :items="items"
          :search="search"
          item-class="qmkey-item-row"
          single-select
          must-sort
          sort-by="readable_path"
          fixed
          small
          dense
          @item-selected="select_directory"
          @click:row="select_directory"
        >
          <template v-slot:item.color="{item}">
            <v-icon :color="item.color">
              mdi-folder
            </v-icon>
          </template>
          <template v-slot:item.name="{item}">
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:item.readable_path="{item}" style="">
            <span
              v-if="(item.readable_path+item.name).length <= 60"
            >
              <span>{{ path_without_current_item(item.readable_path) }}</span>
            </span><!---->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:default;"
                >
                <span>{{ path_without_current_item(item.readable_path).substring(0, 60) + "..." }}</span>
                </span>
              </template>
              <span>{{ path_without_current_item(item.readable_path) }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <div>
            <v-btn icon @click="open_add(item)" :disabled="!can_create">
              <v-icon>mdi-folder-plus-outline</v-icon>
            </v-btn>

            <v-btn icon @click="open_edit(item)" :disabled="!can_create">
              <v-icon>
                mdi-folder-settings-outline
              </v-icon>
            </v-btn>
            <v-btn icon @click="delete_folder_form(item)" :disabled="!can_create || has_children(item)">
              <v-icon>
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </div>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  
    <v-dialog
      v-model="dialog.show"
      max-width="600px"
      @keydown.esc="close"
    >
      <v-card>
        <v-card-title class="modal-card-title">
          <span class="qmkey-modal-h1 pb-0">
            {{ dialog.title }}
          </span>
          <v-spacer></v-spacer>
          
          <v-btn
            class="qmkey-modal-dialog-close"
            text
            plain
            right
            small
            :ripple="false"
            @click="dialog.show = false"
          >
            <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <ExplorerDirectoryPath
                  v-if="!!selected"
                  :path="selected.path"
                ></ExplorerDirectoryPath>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.name"
                  :label="$vuetify.lang.translator('directory.directory_name')"
                  outlined
                  dense
                  background-color="#f2f2f2"
                  class="qmkey-form-input required"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-select
                  v-if="!parent_hidden"
                  v-model="dialog.parent_id"
                  :items="select_directories"
                  :label="$vuetify.lang.translator('directory.father')"
                  :placeholder="$vuetify.lang.translator('directory.select_father')"
                  item-text="name"
                  item-value="id"
                  class="qmkey-form-input"
                  outlined
                  dense
                  background-color="#f2f2f2"
                  clearable
                >
                  <template>
                    <v-icon slot="append" color="primary">
                      {{ false || 'mdi-menu-down' }}
                    </v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                align="center"
                justify="center"
              >
                <v-color-picker
                  v-model="dialog.color"
                  mode="hexa"
                  :swatches="swatches"
                  show-swatches
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
          <v-btn
            class="qmkey-modal-dialog-button-secundary"
            text
            @click="dialog.show = false"
          >
          {{ $vuetify.lang.translator('dialog.cancel') }}
          </v-btn>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            text
            @click="dialog.save"
            :disabled="!valid"
          >
          {{ $vuetify.lang.translator('dialog.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
      :message="message"
    >
    </modal-dialog-form>
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import '@/sass/modalform.scss';
  
  .explorerdirectory-cont {
    @extend .documentation-table-cont-base;
  }
  
  .explorerdirectory-header {
    @extend .documentation-table-header-base;
    display: flex;
    align-items: center;
  }
</style>


<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import QDirectory from '@/api/QDirectory';
  import ExplorerDirectoryPath from '@/components/explorer/ExplorerDirectoryPath';
  import SearchTextTable from '@/components/SearchTextTable';
  import ModalDialogForm from '@/components/explorer/ModalDialog';
  import QTree from '@/utils/QTree'
  
  
  export default {
    name: 'ExplorerDirectoryEditable',
  
    components: {
      ExplorerDirectoryPath,
      SearchTextTable,
      ModalDialogForm,
    },
    
    props: {
      filters: {},
      directories: {},
    },
  
    data: () => ({
      rename_dialog: false,
      dialog: {
        show: false,
        name: '',
        color: '',
        parent_id: '',
        save: function () {},
      },
      search: null,
      directory_colors: [
        '#29a1c5',
        '#404040',
        '#753c8f',
        '#85a43c',
        '#acacac',
        '#ff0000',
        '#f7a42f',
        '#181cbb',
        '#ff66ff',
        '#ffff33',
      ],
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      parent_hidden: false,
      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: '',
      submit_action: function () { },
      message:"",
      table_select: [],
      selected: null,
      show_dialog: false,
    }),
  
    computed: {
      ...mapGetters([
        'centro_id',
        'isManager',
        'isAdmin',
        'user',
      ]),
      
      ...mapState([
        'qdirectory',
      ]),
      
      valid() {
        return !!this.dialog.name
      },

      select_directories() {
        let dirs = this.qdirectory
        if (dirs) {
          return (Object
            .values(dirs)
            .filter((d) => d.id != (this.selected || {}).id && !this.is_son_of_dir(d))
          );
        }
        return [];
      },
  
      can_create() {
        return (
          (this.isAdmin || this.isManager) || 
          (this.user.manager_of_centros 
            ? this.user.manager_of_centros.includes(this.centro_id)
            : false)
        );
      },

      total_folders_count() {
        return Object.keys(this.qdirectory).length;
      },

      items_tree() {
        let v = new QTree()
        v.fromTree(this.directories)
        return v;
      },

      items() {
        return (Object
          .values(this.qdirectory)
          .filter(dir => dir.centro_id == this.centro_id)
          .map(it => ({
            ...it,
            readable_path: this.full_dir_path(it), 
            level: it.path.length + 1, 
            parent_name: this.parent_name(it),
          }))
          .sort((a, b) => a.readable_path.localeCompare(b.readable_path))
        );
      },

      headers() {
        return [
          {
            text: '',
            align: 'start',
            sortable: false,
            filterable: false,
            value: 'color',
          },
          {
            text: this.$vuetify.lang.translator('directory.directory_name'),
            align: 'start',
            sortable: true,
            value: 'name',
          },{
            text: this.$vuetify.lang.translator('directory.level'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'level',
          },{
            text: this.$vuetify.lang.translator('directory.father'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'parent_name',
          },{
            text: this.$vuetify.lang.translator('directory.route'),
            align: 'start',
            sortable: true,
            filterable: false,
            value: 'readable_path',
          },{
            text: '',
            align: 'start',
            sortable: false,
            filterable: false,
            value: 'actions',
          },
        ]
      },
    },
  
    mounted() {
    },
  
    methods: {
      ...mapActions(['LOAD_DIRECTORY_ITEMS']),

      close_dialog() {
        this.show_dialog = false;
      },

      select_directory(a) {
        this.selected = (this.selected === a) ? null : a ;
        this.table_select = this.selected ? [this.selected]: [];
      },

      has_children(item) {
        return (item.children && item.children.length > 0);
      },

      parent_name(item) {
        const parent = this.qdirectory[item.parent_id];
        return parent ? parent.name : '';
      },

      full_dir_path(item) {
        return '/' + item.path.map(id => this.qdirectory[id].name).join('/');
      },

      path_without_current_item(path) {
        return '/' + path.split('/').slice(1, -1).join('/');
      },

      open_add(dir) {
        if (dir.id) {
          this.dialog.title = this.$vuetify.lang.translator('directory.add_subdirectory').toUpperCase() + ' ' + dir.name
          this.dialog.color = dir.color
          this.dialog.parent_id = dir.id
        } else {
          this.dialog.title = this.$vuetify.lang.translator('directory.add_directory').toUpperCase()
          this.dialog.color = this.directory_colors[0]
          this.dialog.parent_id = ''
        }
        this.parent_hidden = true
        this.dialog.show = true
        this.dialog.name = ''
  
        this.dialog.save = () => {
          this.apply_add_folder();
          this.dialog.show = false;
        }
      },
  
      open_edit(directory) {
        if (!directory.id) {
          return; // No selected directory
        }

        this.dialog.show  = true;
        this.dialog.title = this.$vuetify.lang.translator('directory.edit_directory').toUpperCase();
        this.dialog.name  = directory.name;
        this.dialog.color = directory.color;

        this.dialog.parent_id = directory.parent_id ? directory.parent_id : '';

        this.parent_hidden = false;
        this.dialog.save = () => {
          this.apply_edit_folder();
          this.dialog.show = false;
        }
      },
  
      async apply_add_folder() {
        await QDirectory.post(this.centro_id, {
          name: this.dialog.name,
          color: this.dialog.color,
          parent: (this.selected || {}).id,
        });
        this.update_directories();
      },
  
      async apply_edit_folder() {
        await QDirectory.put(this.centro_id, this.selected.id, {
          name: this.dialog.name,
          color: this.dialog.color,
          parent: this.dialog.parent_id || null,
        });
        this.update_directories();
      },
  
      setSearchText(search_text) {
        this.search = search_text;
      },

      delete_folder_form(directory) {
        this.modal_title = (this.$vuetify.lang.translator('directory.delete_directory')
                           + ` #${directory.id}-${directory.name} `);
        this.showModalDialog = true;
        this.fields_to_collect = [];
        this.submit_action = this.delete_folder;
        this.submit_button_caption = this.$vuetify.lang.translator('dialog.delete');
      },

      async delete_folder() {
        try {
          await QDirectory.delete(this.centro_id, this.selected.id,
                                  this.filters.get_filter_value('business_process'));
        } catch (err) {
          this.toggle_dialog();
        }

        this.update_directories();
        this.toggle_dialog();
      },

      update_directories () {
        this.LOAD_DIRECTORY_ITEMS(this.centro_id);
        this.$emit('update');
      },
  
      toggle_dialog() {
        this.showModalDialog = false
        this.modal_title = ``
        this.fields_to_collect = [];
        this.submit_action = (() => {});
        this.submit_button_caption = '';
        this.message = "";
        this.table_select = [];
        this.selected = null;
      },

      is_son_of_dir(dir) {
        const item_selected = this.selected ? [this.selected] : [];
        const parent_and_sons = new QTree(item_selected).plain_tree();
        return !!parent_and_sons.find(itm => itm.id == dir.id);
      },
    },
  
    watch: {
      enable_button: function () {
        this.valid = this.dialog.name ? true : false
      },
    },
  };
</script>
